import summaryMixin from '@/components/AttendanceForm/espondiloartrites/mixins/espondiloartritesSummaryMixin'

export default {
  mixins: [summaryMixin],

  computed: {
    asasPhaseData() {
      return this.getPhaseDataByKey('asas')
    },
    symptomsPhaseDataSymptoms() {
      return this.getPhaseDataByKey('sintomas')?.symptoms
    },
    diseaseActivityPhaseData() {
      return this.getPhaseDataByKey('atividades_doenca')
    },
    computedAsasPeriferico() {
      if (!this.asasPhaseData || !this.symptomsPhaseDataSymptoms) {
        return '?'
      }
      if (
        !this.symptomsPhaseDataSymptoms.artrite_artralgia?.value &&
        !this.symptomsPhaseDataSymptoms.dactilite?.value &&
        !this.symptomsPhaseDataSymptoms.entesite?.value
      ) {
        return '-'
      }

      const valueList1 = [
        this.symptomsPhaseDataSymptoms.uveite?.value,
        this.symptomsPhaseDataSymptoms.psoriase?.value,
        this.asasPhaseData.doenca_inflamatoria_intestinal,
        this.asasPhaseData.infeccao_previa,
        this.asasPhaseData.hla_b27,
        this.computedSacroileiteImagem === '+',
      ]

      const valueList2 = [
        this.symptomsPhaseDataSymptoms.artrite_artralgia?.value,
        this.symptomsPhaseDataSymptoms.dactilite?.value,
        this.symptomsPhaseDataSymptoms.entesite?.value,
        this.asasPhaseData.dor_lombar_inflamatoria_no_passado,
        this.asasPhaseData.historia_familiar_espondiloartrite,
      ]

      return valueList1.reduce((prev, value) => prev + (value ? 1 : 0), 0) >= 1 ||
        valueList2.reduce((prev, value) => prev + (value ? 1 : 0), 0) >= 3
        ? '+'
        : '-'
    },
    articulacoesAcometidasArtrite() {
      if (!this.asasPhaseData) {
        return '?'
      }
      return Object.entries(this.asasPhaseData.articulacoes_acometidas_artrite)
        .filter((a) => a[1].selected)
        .map((a) => ({ key: a[0], value: a[1] }))
    },
    computedArticulacoesDolorosas() {
      if (!this.asasPhaseData) {
        return '?'
      }
      return this.articulacoesAcometidasArtrite.filter((a) => a.value.dorSelected).length
    },
    computedArticulacoesInchadas() {
      if (!this.asasPhaseData) {
        return '?'
      }
      return this.articulacoesAcometidasArtrite.filter((a) => a.value.inchSelected).length
    },
    areasAcometidasEntesite() {
      if (!this.asasPhaseData) {
        return '?'
      }
      return Object.entries(this.asasPhaseData.areas_acometidas_entesite)
        .filter((a) => a[1].selected)
        .map((a) => ({ key: a[0], value: a[1] }))
    },
    areasAcometidasDactilite() {
      if (!this.asasPhaseData) {
        return '?'
      }
      return Object.entries(this.asasPhaseData.areas_acometidas_dactilite)
        .filter((a) => a[1].selected)
        .map((a) => ({ key: a[0], value: a[1] }))
    },

    computedDas28() {
      if (
        !this.asasPhaseData ||
        !this.diseaseActivityPhaseData ||
        this.diseaseActivityPhaseData.velocidade_hemossedimentacao_vhs.value == null ||
        this.computedArticulacoesDolorosas == null ||
        this.computedArticulacoesInchadas == null
      ) {
        return '?'
      }
      return (
        Math.round(
          (0.56 * Math.sqrt(this.computedArticulacoesDolorosas) +
            0.28 * Math.sqrt(this.computedArticulacoesInchadas) +
            0.7 * Math.log(Number(this.diseaseActivityPhaseData.velocidade_hemossedimentacao_vhs.value)) +
            0.014 * this.computedEva * 10) *
            100,
        ) / 100
      ).toFixed(2)
    },
    computedDapsa() {
      let pcr = this.diseaseActivityPhaseData?.proteina_c_reativa

      if (
        !this.diseaseActivityPhaseData ||
        !this.asasPhaseData ||
        !pcr ||
        !pcr.dosageUnit ||
        pcr.value == null ||
        pcr.value == '' ||
        this.computedArticulacoesDolorosas == null ||
        this.computedArticulacoesInchadas == null ||
        this.diseaseActivityPhaseData.nivel_atividade_doenca_reumatologica_ultima_semana == null ||
        this.diseaseActivityPhaseData.nivel_dor_articular_ultima_semana == null
      ) {
        return '?'
      }

      if (pcr.dosageUnit === 'MG_DL') {
        pcr = Number(pcr.value)
      } else {
        pcr = Number(pcr.value) / 10
      }
      return (
        Math.round(
          (this.computedArticulacoesDolorosas +
            this.computedArticulacoesInchadas +
            this.diseaseActivityPhaseData.nivel_atividade_doenca_reumatologica_ultima_semana +
            this.diseaseActivityPhaseData.nivel_dor_articular_ultima_semana +
            pcr) *
            100,
        ) / 100
      ).toFixed(2)
    },
  },
}
